<template>
  <div class="common-footer">
    <p class="copy-right">© 2004-2020 www.autohome.com.cn All Rights Reserved.汽车之家 版权所有</p>
    <!-- <ul class="concat-us">
      <li>法律声明</li>
      <span></span>
      <li>联系我们</li>
    </ul> -->
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped>
.common-footer {
  height: 62px;
  line-height: 62px;
  /* height: 8.1vh;
  line-height: 8.1vh; */
  background: #1D1D1E;
  color: #fff;
  font-family: 'PingFangSC-Regular';
  margin-top: -2px;
}
.copy-right {
  float: left;
  margin-left: 65px;
  font-size: 14px;
  color: #F7F9FA;
  opacity: 0.5;
}
.concat-us {
  float: right;
  margin-right: 66px;
  opacity: 0.5;
  font-size: 14px;
  color: #F7F9FA;
}
.concat-us li {
  float: left;
  cursor: pointer;
}
.concat-us span {
  float: left;
  width: 1px;
  height: 2vh;
  margin: 3.1vh 18px 0;
  background-color: rgba(255, 255, 255, 05);
}
</style>



// WEBPACK FOOTER //
// src/components/mainfooter.vue